export default {
  app: {
    name: 'Application name',
    type: String,
    txtDescr: 'Name of the current application',
    default: (v, sett) => ''
  },
  lengthMax: {
    name: 'Maximum saved messages',
    type: Number,
    txtDescr: 'Maximum number of saved messages',
    txtError: 'It should be non negative integer',
    validator: (v, sett) => v>=0,
    default: (v, sett) => 1000
  },
  fatal: {
    name: 'Save fatals',
    type: Boolean,
    txtDescr: 'If true, then fatal messages will be saved',
    default: (v, sett) => true
  },
  err: {
    name: 'Save errors',
    type: Boolean,
    txtDescr: 'If true, then error messages will be saved',
    default: (v, sett) => true
  },
  warn: {
    name: 'Save warnings',
    type: Boolean,
    txtDescr: 'If true, then warning messages will be saved',
    default: (v, sett) => true
  },
  res: {
    name: 'Save results',
    type: Boolean,
    txtDescr: 'If true, then operations result messages will be saved',
    default: (v, sett) => true
  },
  proc: {
    name: 'Save procceses',
    type: Boolean,
    txtDescr: 'If true, then operations proccess messages will be saved',
    default: (v, sett) => true
  },
  debug: {
    name: 'Save debug',
    type: Boolean,
    txtDescr: 'If true, then debug messages will be saved',
    default: (v, sett) => false
  },
  debugCn: {
    name: 'Save debug CN',
    type: Boolean,
    txtDescr: 'If true, debug messages from Connection module will be saved',
    default: (v, sett) => true
  },
  debugDb: {
    name: 'Save debug DB',
    type: Boolean,
    txtDescr: 'If true, debug messages from Database module will be saved',
    default: (v, sett) => true
  },
  debugRb: {
    name: 'Save debug RB',
    type: Boolean,
    txtDescr: 'If true, debug messages from Robot module will be saved',
    default: (v, sett) => true
  },
  debugSt: {
    name: 'Save debug ST',
    type: Boolean,
    txtDescr: 'If true, debug messages from Settings module will be saved',
    default: (v, sett) => true
  },
  write: {
    name: 'Print to browser console',
    type: Boolean,
    txtDescr: 'If true, then saved messages will be printed',
    default: (v, sett) => false
  },
  isServer: {
    name: 'Server',
    type: Boolean,
    txtDescr: 'Is true for server side instanse',
    editable: (v, sett) => false,
    default: (v, sett) => false
  },
  isPlugin: {
    name: 'Plugin',
    type: Boolean,
    txtDescr: 'Is true for plugin side instanse',
    editable: (v, sett) => false,
    default: (v, sett) => false
  },
  browser: {
    name: 'Browser',
    type: String,
    enum: ['chrome', 'safari', 'opera', 'firefox', 'explorer', 'unknown'],
    txtDescr: 'Name of the used browser',
    editable: (v, sett) => false,
    enabled: (v, sett) => !sett.isServer,
    default: (v, sett) => 'unknown'
  }
}



// WEBPACK FOOTER //
// ./src/cs/sett.js